// extracted by mini-css-extract-plugin
module.exports = {"modal":"_26jnbt","title":"_2DV7rn","text":"_2ue4vN"};